import whitelist from 'validator/lib/whitelist';

export const cleanPostcode = (postcode = '') => whitelist(postcode, '0-9');

export const isValidPostcode = (postcode = '') =>
    cleanPostcode(postcode).length === 7;
